import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "hover:bg-gray-50 text-left" }
const _hoisted_2 = { class: "px-4 py-2 text-gray-900 text-sm font-medium leading-5 border-b" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "px-4 py-2 text-gray-900 text-sm font-medium leading-5 border-b" }
const _hoisted_7 = { class: "flex flex-col" }
const _hoisted_8 = { class: "px-4 py-2 font-medium text-xs leading-4 border-b" }
const _hoisted_9 = { class: "flex justify-center px-4 py-2 border-b" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("tr", _hoisted_1, [
    _createElementVNode("td", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.row.user.slug && _ctx.programSlug)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: _ctx.getExpertCalendarUrl(_ctx.row.user.slug),
              target: "_blank",
              rel: "noopener noreferrer",
              class: "text-blue-600 hover:text-blue-800 hover:underline"
            }, _toDisplayString(_ctx.row.user.firstName + " " + _ctx.row.user.lastName), 9, _hoisted_4))
          : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.row.user.firstName + " " + _ctx.row.user.lastName), 1))
      ])
    ]),
    _createElementVNode("td", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", null, _toDisplayString(_ctx.row.user.email), 1)
      ])
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("td", { class: "px-4 py-2 font-medium text-xs leading-4 border-b" }, "--", -1)),
    _cache[3] || (_cache[3] = _createElementVNode("td", { class: "px-4 py-2 font-medium text-xs leading-4 border-b" }, [
      _createElementVNode("div", { class: "relative inline-block group" }, [
        _createElementVNode("span", { class: "px-2 rounded-lg text-gray-800 bg-orange-100" }, "Applied"),
        _createElementVNode("div", { class: "absolute left-1/2 -translate-x-1/2 top-full mt-1 w-max max-w-xs px-2 py-1 text-xs text-white bg-gray-900 rounded-md opacity-0 group-hover:opacity-100 transition-opacity shadow-lg z-50 pointer-events-none" }, " Signed up via email invite, landing page invite, or software search and then applied to join your program. ")
      ])
    ], -1)),
    _createElementVNode("td", _hoisted_8, " Applied on " + _toDisplayString(_ctx.convertToDate(_ctx.row.createdAt)), 1),
    _createElementVNode("td", _hoisted_9, [
      _createVNode(_component_BaseButton, {
        type: "button",
        class: "flex justify-center text-xs items-center py-2 px-4 rounded-md bg-indigo-100 text-primary-purple",
        style: {"width":"auto"},
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('review', _ctx.rowIndex)))
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode(" Approve ")
        ])),
        _: 1
      })
    ])
  ]))
}